module.exports = __webpack_public_path__ + "img/bus-icon.9a378136.svg";